<template>
  <div class="mb-10" data-testid="waitlist-registration-drawer-view">
    <!-- 予約フォームと同じ位置に見出しを固定し、ドロワー内の画面遷移であることを示す -->
    <div class="fixed left-0 right-0 top-[1rem] z-[2] flex w-full items-center gap-x-3 border-b border-solid border-beige3 bg-white p-4 md:top-0">
      <button aria-label="Back to date selection" class="-m-2 shrink-0 cursor-pointer rounded-lg p-2 hover:bg-gray5" data-testid="waitlist-registration-back" type="button" @click="props.onBack">
        <img alt="" class="h-[18px] w-[10px]" src="~@/assets/img/parts/top-left.svg" />
      </button>
      <p class="text-[16px] md:text-[17px]">Get availability alerts</p>
    </div>
    <!-- pt は固定ヘッダーの高さ 56px 分に余白を足した値 -->
    <div class="bg-white px-4 pb-8 pt-20 md:px-8">
      <AnimatedContentSwap>
        <div v-if="hasRegistered">
          <WaitlistRegistrationThankYouMessage />
          <AtomsPrimaryButton class="mt-8 w-full" data-testid="waitlist-registration-done-back" :on-click="props.onBack">Back to date selection</AtomsPrimaryButton>
        </div>
        <WaitlistRegistrationForm v-else :experience-id="props.experienceId" :experience-name="props.experienceName" :on-success="onRegistered" />
      </AnimatedContentSwap>
    </div>
  </div>
</template>

<script lang="ts" setup>
import AtomsPrimaryButton from '@/components/atoms/PrimaryButton/PrimaryButton.vue';
import AnimatedContentSwap from '@/wabunka-src/features/Experience/pages/ExperienceDetail/components/pure/AnimatedContentSwap/AnimatedContentSwap.vue';
import WaitlistRegistrationThankYouMessage from '@/wabunka-src/features/Experience/pages/ExperienceDetail/components/pure/WaitlistRegistrationThankYouMessage/WaitlistRegistrationThankYouMessage.vue';
import WaitlistRegistrationForm from '@/wabunka-src/features/Experience/pages/ExperienceDetail/components/stateful/WaitlistRegistrationForm/WaitlistRegistrationForm.vue';

interface Props {
  experienceId: string;
  experienceName: string;
  /**
   * 予約フォームへ戻す。ドロワーを閉じずにビューだけ切り替える
   */
  onBack: () => void;
}

const props = defineProps<Props>();

const hasRegistered = ref(false);
const onRegistered = () => {
  hasRegistered.value = true;
};
</script>
